import { render } from "./AppConfirmDialog.vue?vue&type=template&id=223dd8da&scoped=true"
import script from "./AppConfirmDialog.vue?vue&type=script&lang=js"
export * from "./AppConfirmDialog.vue?vue&type=script&lang=js"

import "./AppConfirmDialog.vue?vue&type=style&index=0&id=223dd8da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223dd8da"]])

export default __exports__